/* eslint-disable react/prop-types */
import React from "react"
import styles from "./styles"
import { Button, MenuItem } from "@material-ui/core"
import withStyles from "@material-ui/core/styles/withStyles"
import ArrowIcon from "@material-ui/icons/ArrowDropDown"
import classnames from "clsx"

const types = {
  Button,
  MenuItem,
}

const SortButton = ({
  control,
  classes,
  onClick,
  activeSort,
  isMenuItem,
  props = {},
}) => {
  const Component = types[isMenuItem ? "MenuItem" : "Button"]
  return (
    <Component
      className={classes.sortControlsButton}
      disableRipple
      color="secondary"
      size="small"
      onClick={() => onClick(control.value)}
      {...props}
    >
      {control.label}
      <ArrowIcon
        className={classnames(classes.arrowIcon, {
          [classes.arrowIconAsc]:
            activeSort[0] === control.value && activeSort[1] === "ASC",
        })}
        style={{
          opacity: activeSort[0] === control.value ? 1 : 0,
        }}
      />
    </Component>
  )
}

export default withStyles(styles, { withTheme: true, name: "CAT" })(SortButton)
